// src/pages/Faq/Faq.tsx
import React, { useState, useEffect } from 'react';
import parse from 'html-react-parser';
import { useParams } from 'react-router-dom';
import styles from './styles.module.sass';
import Page from '../../layouts/Page';
import FaqItem from '../../components/FaqItem';
import TextBlock from '../../components/TextBlock';
import { hostname } from '../../constants';

interface FaqEntry {
  id: number;
  title: { rendered: string };
  content: { rendered: string };
  _embedded?: any;
}

const emailMap: Record<string, string> = {
  singapore: 'mail@lloydsinn.com',
  bali: 'bali@lloydsinn.com',
  'kuala-lumpur': 'kualalumpur@lloydsinn.com',
};

const phoneMap: Record<string, string> = {
  singapore: '+65 6737 7309',
  bali: '+62 361 475 5560',
  'kuala-lumpur': '+60 3 2777 8988',
};

const Faq: React.FC = () => {
  const { country = '' } = useParams<Record<string, string>>();
  const [faqs, setFaqs] = useState<FaqEntry[]>([]);

  useEffect(() => {
    fetch(
      `${hostname}/${country}/wp-json/wp/v2/faq?_embed&per_page=100&order=desc`
    )
      .then(res => res.json())
      .then((data: FaqEntry[]) => setFaqs(data))
      .catch(console.error);
  }, [country]);

  if (faqs.length === 0) return null;

  const email = emailMap[country] || '';
  const phone = phoneMap[country] || '';

  return (
    <Page type="local" className={styles.base} country={country}>
      <TextBlock>
        <p>
          Travellers often have the same concerns and you can find
          <br /> answers to commonly-asked questions below. If you can’t
          <br /> find what you’re looking for in our FAQ, feel free to email
          <br /> us at <a href={`mailto:${email}`}>{email}</a> or call us at{' '}
          <span className="nobr">{phone}</span>.
        </p>
      </TextBlock>
      {faqs.map(faq => (
        <FaqItem key={faq.id} question={parse(faq.title.rendered)}>
          {parse(faq.content.rendered)}
        </FaqItem>
      ))}
    </Page>
  );
};

export default Faq;
